// extracted by mini-css-extract-plugin
export default {"header":"Details_header__6Uo0q","separator":"Details_separator__-lmh4","bankList":"Details_bankList__LJuJx"};